import Vue from 'vue'

export const ACCESO_BLOQUEADO_EVENT = 'rh-acceso-bloqueado-actualizar'
export const ACCESO_BLOQUEADO_ACTIVO_EVENT = 'rh-acceso-bloqueado-activo'
export const accesoBloqueadoBus = new Vue()

export function notificarAccesoBloqueadoActualizar(mensaje) {
  accesoBloqueadoBus.$emit(
    ACCESO_BLOQUEADO_EVENT,
    mensaje || 'Acceso denegado, Favor de actualizar su plataforma'
  )
}

export function notificarAccesoBloqueadoActivo(bloqueado = true) {
  accesoBloqueadoBus.$emit(ACCESO_BLOQUEADO_ACTIVO_EVENT, Number(bloqueado) === 1 ? 1 : 0)
}

export function esErrorAccesoBloqueado(error) {
  const data = error && error.response && error.response.data
  if (!data) return false
  if (data.code === 'ACCESO_BLOQUEADO') return true
  const msg = typeof data.message === 'string' ? data.message : ''
  return /acceso denegado.*actualizar su plataforma/i.test(msg)
}

export function mensajeErrorAccesoBloqueado(error) {
  const data = error && error.response && error.response.data
  return (data && data.message) || 'Acceso denegado, Favor de actualizar su plataforma'
}
